
// import { Options, Vue } from "vue-class-component";
// import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'
import {
  onBeforeUnmount,
  onMounted,
  onActivated,
  inject,
  ref,
  reactive,
  Ref,
  nextTick,
  getCurrentInstance,
  computed,
} from "vue";
import { getVersionInfo } from "@/api/aio";
import { getUrlParam } from "../../utils/parseUrl";
import { isIOS } from "@/assets/js/utils"
export default {
  components: {},
  setup() {
    const $xesLog = inject("$xesLog") as any; // 埋点
    const u = navigator.userAgent;
    const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    const isWxBowser = ref(u.toLocaleLowerCase().indexOf("micromessenger") > -1);
    const downloadUrlAndroid = ref("");
    const downloadUrlIos = ref("");
    // const channelName = getUrlParam(window.location.href, "channelName");
    const channelNameCode = getUrlParam(window.location.href, "sl");
    const channelMap = {
      0: "share_common",
      1: "pop_up_1star",
    };
    const reportDataMap = {
      page_name: "app_download",
      button_name: "app_download_button",
    };
    const getVersion = () => {
      getVersionInfo().then((res) => {
        if (res.data.code !== 0) {
          return;
        }
        if (!isIOS()) {
          downloadUrlAndroid.value = res.data.data.update.file_path_url;
        } else {
          downloadUrlIos.value = res.data.data.update.itunes_url;
        }
      });
    };
    const callApp = () => {
      // 唤起成功
      $xesLog.track(
        "component_call",
        {
          ...reportDataMap,
          source_location: channelMap?.[channelNameCode] || "",
          component_name: "app_open_call",
          if_call_success: 1,
        },
        () => {
          console.log("唤起埋点成功");
        }
      );

      $xesLog.track(
        "button_click",
        {
          ...reportDataMap,
          source_location: channelMap?.[channelNameCode] || "",
          button_status: 2,
        },
        () => {
          console.log("点击唤起");
        }
      );
      window.top.location.href = "xueersi://com.tal.publish.book/main";
      checkOpen();
    };
    /**
     * 获取页面隐藏属性的前缀
     * 如果页面支持 hidden 属性，返回 '' 就行
     * 如果不支持，各个浏览器对 hidden 属性，有自己的实现，不同浏览器不同前缀，遍历看支持哪个
     */
    const getPagePropertyPrefix = () => {
      const prefixes = ["webkit", "moz", "ms", "o"];
      let correctPrefix;
      if ("hidden" in document) return "";
      prefixes.forEach((prefix) => {
        if (`${prefix}Hidden` in document) {
          correctPrefix = prefix;
        }
      });
      return correctPrefix || false;
    };
    /**
     * 判断页面是否隐藏（进入后台）
     */
    const isPageHidden = () => {
      const prefix = getPagePropertyPrefix();
      if (prefix === false) return false;
      const hiddenProperty = prefix ? `${prefix}Hidden` : "hidden";
      return window.document[hiddenProperty];
    };
    /**
     * 获取判断页面 显示|隐藏 状态改变的属性
     */
    const getVisibilityChangeProperty = () => {
      const prefix = getPagePropertyPrefix();
      if (prefix === false) return false;
      return `${prefix}visibilitychange`;
    };
    /**
     * 检测是否唤端成功
     */
    const checkOpen = () => {
      const visibilityChangeProperty = getVisibilityChangeProperty();
      const timer = setTimeout(() => {
        const hidden = isPageHidden();
        if (!hidden) {
          console.log('hidden---')
          // 点击下载app
          $xesLog.track(
            "app_download",
            {
              ...reportDataMap,
              source_location: channelMap?.[channelNameCode] || "",
              button_status: 1,
            },
            () => {
              console.log("点击下载埋点成功");
            }
          );
          // app唤起失败
          $xesLog.track(
            "component_call",
            {
              ...reportDataMap,
              source_location: channelMap?.[channelNameCode] || "",
              component_name: "app_open_call",
              if_call_success: 2,
            },
            () => {
              console.log("唤起失败埋点成功");
            }
          );
          if (!isIOS()) {
            window.top.location.href = downloadUrlAndroid.value;
            console.log(downloadUrlAndroid.value, "downloadUrlAndroid.value");
          } else {
            window.top.location.href = downloadUrlIos.value;
          }
        }
      }, 2000);
      if (visibilityChangeProperty) {
        document.addEventListener(visibilityChangeProperty, (res) => {
          clearTimeout(timer);
        });
        return;
      }
      window.addEventListener("pagehide", () => {
        clearTimeout(timer);
      });
    };
    onMounted(() => {
      getVersion();
      $xesLog.view(
        "page_view",
        {
          page_name: reportDataMap.page_name,
          source_location: channelMap?.[channelNameCode] || "",
        },
        () => {
          console.log("pv");
        }
      );
    });
    return {
      isWxBowser,
      callApp,
    };
  },
};
